import { Box, Text } from '@chakra-ui/react';
import React from 'react';
import PropTypes from 'prop-types';

export function StatusLine({ name, objectKey, amount }) {
  const colors = {
    'in-voorbereiding': 'blue',
    beschikbaar: 'green',
    'in-optie': 'yellow',
    verkocht: 'red',
  };

  return (
    <Box
      display="flex"
      flexDir="row"
      gap={3}
      borderTop="1px solid"
      borderColor="primary.border.default"
      paddingY={0.5}
      alignItems="center"
    >
      <Box className={`category-circle ${colors[objectKey]}`}></Box>
      <Text fontSize={13} fontWeight="semibold">
        {name}: <b>{amount}</b>
      </Text>
    </Box>
  );
}

StatusLine.propTypes = {
  name: PropTypes.string.isRequired,
  amount: PropTypes.number.isRequired,
  objectKey: PropTypes.string.isRequired,
};
